import type {NavigateFunction} from "react-router-dom";

import {dispatchShiftComplianceGateFromPushData} from "./dispatch-shift-compliance-gate-from-notification";
import {
  markNotificationReadFromPushData,
  stripPushClickSearchParams,
} from "./mark-notification-read-from-push";

/** OS notification tap — compliance modal, mark-read, navigate. Does not change property context. */
export function handlePushNotificationClick(
  data: Record<string, unknown>,
  navigate: NavigateFunction,
  path: string,
): void {
  dispatchShiftComplianceGateFromPushData(data);

  void markNotificationReadFromPushData(data);

  const [pathname, query = ""] = path.split("?");
  const cleanedSearch = stripPushClickSearchParams(new URLSearchParams(query));
  navigate(`${pathname}${cleanedSearch}`);
}
